// pages/Services.js
import React from "react";
import Header from "../components/home/Header";

import Footer from "../components/home/Footer";
import HrService from '../components/services/HrService';



function HrServicePage() {
  return (
    <div>
      <Header />
      <HrService/>
   
      <Footer />
    </div>
  );
}

export default HrServicePage;
